import { render, staticRenderFns } from "./sharingFriend.vue?vue&type=template&id=590906ea&scoped=true"
import script from "./sharingFriend.vue?vue&type=script&lang=js"
export * from "./sharingFriend.vue?vue&type=script&lang=js"
import style0 from "./sharingFriend.vue?vue&type=style&index=0&id=590906ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590906ea",
  null
  
)

export default component.exports